import { render, staticRenderFns } from "./ContractConfigView.vue?vue&type=template&id=f13264e4&scoped=true"
import script from "./ContractConfigView.vue?vue&type=script&lang=js"
export * from "./ContractConfigView.vue?vue&type=script&lang=js"
import style0 from "./ContractConfigView.vue?vue&type=style&index=0&id=f13264e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13264e4",
  null
  
)

export default component.exports